<template>
  <div class="swi" :ref="'swiper' + bannerType">
    <mt-swipe class="swiper1" :auto="4000" v-if="!list" @change="bannerChange1">
      <template v-for="(img, index) in imgs">
        <mt-swipe-item class="swiper-item" :key="index" v-if="imgs.length > 0 && (img.is_show || $isTest)"
          ><img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click="chooseOne(img)"
          />
          <mt-swipe class="swiper" :auto="4000"></mt-swipe>
        </mt-swipe-item>
      </template>
    </mt-swipe>
    <mt-swipe
      class="swiper2"
      :auto="4000"
      v-if="list"
      @change="bannerChange2"
      :style="
        bannerType == 3
          ? 'height:3.19rem;border-radius: 10px;'
          : bannerType == 4
          ? 'height:2rem;border-radius: 10px;'
          : bannerType == 5
          ? 'height:2rem;border-radius: 0;'
          : bannerType == 6
          ? 'height:3.7333rem;border-radius: 0;'
          : ''
      "
    >
      <template v-for="(img, index) in localList">
        <mt-swipe-item class="swiper-item" :key="index" v-if="img.is_show || $isTest"
          >
          <img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click="chooseOne(img)"
          />
          <!-- 不能再swiper-item上使用定位，会导致轮播图轮播动画出问题，使用div包裹开放标签，再覆盖到图片上 -->
          <div class="open-launch-box" v-if="img.showWxOpenTag">
            <wx-open-launch-weapp  :id="`launch-btn-${img.appId}`" :appid="img.appId" :path="img.path"
                style=" position: absolute; width: 100%; display: block; height: 100%; left: 0; top: 0;">
              <script type="text/wxtag-template">
              <style>
                .item-box{
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                  z-index: 30;
                  opacity:0.0;
                }
              </style>
              <div class="item-box">开放标签</div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </mt-swipe-item>
      </template>
    </mt-swipe>
  </div>
</template>

<script>
import { setPiontByHosAndDepAndDocInfo } from '@/pages/registration/setPiont/setPiontRegistretion'
export default {
  props: {
    list: {
      type: Array
    },
    bannerType: {
      type: Number
    },
    setPiontData: {
      type:Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      imgs: [],
      topbanner_flge: 0,
      bannerChange_flge: 0,
      banner_index:1,
      localList: []
    }
  },
  watch: {
    list: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // 遍历查看是否有跳转到小程序的轮播，只针对跳转时处理，所以其他地方还是使用list

          let isWebview = this.$is_wx || localStorage.getItem('is_wx')
          this.localList = newVal.map(item => {
            if(!item.ad_url){
              // 如果是跳转到小程序的，页面地址必须按改标准填写，miniapp://appid=XXXXX&path=XXXXX&appName=XXXXX
              const { appid, path, appName } = this.parseMiniappUrl(item.remark)
              // 如果没有解析到appid，那就不设置小程序信息，不展示开放标签
              if (appid) {
                item.appId = appid
                item.path = path
                item.appName = appName
              }
            }
            item.showWxOpenTag = item.appId && isWebview == 0;
            return {...item}
          })
        } else {
          this.localList = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    chooseOne(data) {
      let _this = this
      if(!this.setPiontData || this.setPiontData == {} ){
        this.hina.track('EV_CHECK_BANNER_CLICK', {
          adv_banner_id: data.id,
        })
      }else{
        console.log(data)
        const adv_banner_id = data.id
        const banner_name = data.banner_name
        const adv_url = data.ad_url
        switch (this.setPiontData.hinaName) {
          case 'EV_OD_BANNER':
          setPiontByHosAndDepAndDocInfo('EV_OD_BANNER_CLICK',_this.setPiontData.doc_id,
            {
              ..._this.setPiontData.data
            })
            break;
          case 'EV_MINE_BANNER':
            window.track_try_catch('EV_MINE_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_REGISTRATION_RECORD':
            window.track_try_catch('EV_REGISTRATION_RECORD_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_ONLINE_PAYMENT_BANNER':
            window.track_try_catch('EV_ONLINE_PAYMENT_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_VACCINE_BANNER':
            window.track_try_catch('EV_VACCINE_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_HOME_REPORT_BANNER':
            window.track_try_catch('EV_HOME_REPORT_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_SD_BANNER':
            window.track_try_catch('EV_SD_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_CTCM_BANNER':
            window.track_try_catch('EV_CTCM_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_SEARCH_BANNER':
            window.track_try_catch('EV_SEARCH_BANNER_CLICK', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          default:
            break;
        }
      }
      // 统计点击次数
      let datas = localStorage.getItem('authtoken')
      if (!datas) {
        if (window.wx) {
          if (data.id || data.id === 0) {
            window.axiosBaseApi.put(`/v1/advertisement/${data.id}`).then((res) => {})
          }
          // 如果在微信小程序的webview中，且有appid，就跳转到小程序
          if(data.appId){
            window.wx.miniProgram.navigateTo({
              url: `/pages/transit/index?type=tominiapp&appId=${data.appId}&path=${encodeURIComponent(data.path)}&appName=${data.appName}`
            })
            return
          }
          // 跳转链接
          if (data.ad_url === '') {
            return
          }
          location.href = data.ad_url
        } else {
          this.$router.push('/user_regiter')
        }
        return
      }
      if (data.id || data.id === 0) {
        window.axiosBaseApi.put(`/v1/advertisement/${data.id}`).then((res) => {})
      }

      // 如果在微信小程序的webview中，且有appid，就跳转到小程序
      let isWebview = this.$is_wx || localStorage.getItem('is_wx')
      if(isWebview == 1 && data.appId){
        window.wx.miniProgram.navigateTo({
          url: `/pages/transit/index?type=tominiapp&appId=${data.appId}&path=${encodeURIComponent(data.path)}&appName=${data.appName}`
        })
        return
      }
      // 如果是在h5中，有appid，直接返回，因为已经使用开放标签处理了
      if(data.appId){
        return
      }

      // 跳转链接
      if (data.ad_url === '') {
        return
      }
      location.href = data.ad_url
    },
    elementInViewport() {
      let el = this.$refs['swiper' + this.bannerType]
      let arry = el.getBoundingClientRect()
      let top = arry.top
      let left = arry.left
      let width = arry.width
      let height = arry.height
      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
        left += el.offsetLeft
      }
      return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        top + height <= window.pageYOffset + window.innerHeight &&
        left + width <= window.pageXOffset + window.innerWidth
      )
    },
    bannerChange1(index) {
      this.topBannerShow = this.elementInViewport()
      if (this.topBannerShow) {
        window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index)].id}&type=1&index=${index}`).then((res) => {})
      }
      // console.log(this.topbanner_flge)
      // if (this.topbanner_flge >= 6) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   return
      // } else {
      //   this.topbanner_flge = 0
      // }
      // if (this.bannerChange_flge < 7) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   console.log(Number(index))
      //   console.log(this.imgs[Number(index) - 1])
      //   console.log(this.imgs[Number(index) - 1].title)
      //   window.axiosBaseApi.get(`http://192.168.1.27:8023/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index) - 1].id}&type=${this.type}`).then(res => {
      //     console.log('手动浏览请求成功')
      //   })
      // }
    },
    bannerChange2(index) {
      let _this = this
      this.topBannerShow = this.elementInViewport()
      if (this.topBannerShow) {
        window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.list[Number(index)].id}&type=1&index=${index}`).then((res) => {})
      }

      if(index == 0){
        this.banner_index --
      }
      if(this.banner_index >= 0 ){
        if(!this.setPiontData || this.setPiontData == {} ){
          this.hina.track('EV_CHECK_BANNER_VIEW', {
            adv_banner_id: this.list[Number(index)].id,
          })
        }else{
          const adv_banner_id = this.list[Number(index)].id
          const banner_name = this.list[Number(index)].banner_name
          const adv_url = this.list[Number(index)].ad_url
          switch (this.setPiontData.hinaName) {
            case 'EV_OD_BANNER':
              setPiontByHosAndDepAndDocInfo('EV_OD_BANNER_SHOW',_this.setPiontData.doc_id,
              {
                ..._this.setPiontData.data
              })
              break;
            case 'EV_MINE_BANNER':
              window.track_try_catch('EV_MINE_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_REGISTRATION_RECORD':
              window.track_try_catch('EV_REGISTRATION_RECORD_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_ONLINE_PAYMENT_BANNER':
              window.track_try_catch('EV_ONLINE_PAYMENT_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_VACCINE_BANNER':
              window.track_try_catch('EV_VACCINE_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_HOME_REPORT_BANNER':
              window.track_try_catch('EV_HOME_REPORT_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_SD_BANNER':
              window.track_try_catch('EV_SD_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_CTCM_BANNER':
              window.track_try_catch('EV_CTCM_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            case 'EV_SEARCH_BANNER':
              window.track_try_catch('EV_SEARCH_BANNER_SHOW', {
                adv_banner_id,
                banner_name,
                adv_url
              })
              break;
            default:
              break;
          }
        }
      }
    },
    // * 解析 miniapp 路径miniapp://appid=xxx&path=xxx&appName=xxx，返回 { appid, path, appName }
    parseMiniappUrl(url) {
      if (!url || !url.startsWith('miniapp://')) return { appid: '', path: '', appName: '' };
      // 只考虑 appid、path、appName，且 appName 在最后
      const reg = /^miniapp:\/\/appid=([^&]*)&path=(.*?)(?:&appName=([^&]*))?$/;
      const match = url.match(reg);
      return {
        appid: match && match[1] ? decodeURIComponent(match[1]) : '',
        path: match && match[2] ? decodeURIComponent(match[2]) : '',
        appName: match && match[3] ? decodeURIComponent(match[3]) : '',
      };
    }
  },
  created() {
    if (this.list && this.list.length > 0) {
      window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.list[0].id}&type=1&index=0`).then((res) => {})
      if (this.type === 2) {
        // 支付页广告
        window.axiosBaseApi.get(`/v1/carousel`).then((res) => {
          if (res.data.code === 1) {
            this.imgs = res.data.data
          } else {
            alert(res.data.msg)
          }
        })
      }
    }
  },
  mounted() {
    let _this = this
    if(this.list && this.list.length > 0) {
      if(!this.setPiontData || this.setPiontData == {} ){
        this.hina.track('EV_CHECK_BANNER_VIEW', {
        adv_banner_id: this.list[0].id,
      })
      }else{
        const adv_banner_id = this.list[Number(0)].id
        const banner_name = this.list[Number(0)].banner_name
        const adv_url = this.list[Number(0)].ad_url
        switch (this.setPiontData.hinaName) {
          case 'EV_OD_BANNER':
          setPiontByHosAndDepAndDocInfo('EV_OD_BANNER_SHOW',_this.setPiontData.doc_id,
            {
              ..._this.setPiontData.data
            })
            break;
          case 'EV_MINE_BANNER':
            window.track_try_catch('EV_MINE_BANNER_SHOW', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_REGISTRATION_RECORD':
            window.track_try_catch('EV_REGISTRATION_RECORD_SHOW', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_ONLINE_PAYMENT_BANNER':
            window.track_try_catch('EV_ONLINE_PAYMENT_BANNER_SHOW', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_VACCINE_BANNER':
            window.track_try_catch('EV_VACCINE_BANNER_SHOW', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          case 'EV_HOME_REPORT_BANNER':
            window.track_try_catch('EV_HOME_REPORT_BANNER_SHOW', {
              adv_banner_id,
              banner_name,
              adv_url
            })
            break;
          default:
            break;
        }
      }

    }

    // let vm = this
    // setInterval(function () {
    //   console.log(vm.bannerChange_flge)
    //   if (vm.bannerChange_flge === 7) {
    //     vm.bannerChange_flge = 0
    //   }
    //   vm.bannerChange_flge += 1
    //   vm.topBannerShow = vm.elementInViewport()
    //   console.log(vm.topBannerShow)
    //   if (vm.topBannerShow) {
    //     vm.topbanner_flge += 1
    //   } else {
    //     vm.topbanner_flge = 0
    //   }
    // }, 1000)
  }
}
</script>

<style lang="less">
.swiper1 {
  width: 100%;
  height: 4.56rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      width: 100%;
      height: 100%;
    }

  }
}
.swiper2 {
  width: 100%;
  height: 1.73rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
    .open-launch-box {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      transform: translateY(-100%);
      pointer-events: auto;
      z-index: 20;
    }
  }
  .mint-swipe-indicator {
    width: 10px !important;
    height: 2px !important;
  }
}
</style>
